import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const RoomAvailabilityCalendar = () => {
    const navigate = useNavigate();
    const [availability, setAvailability] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [viewDate, setViewDate] = useState(new Date());

    // Colors from SRS Matha inspection
    const greenGradient = 'linear-gradient(45deg, rgb(121, 174, 129), rgb(49, 145, 65))';
    const redColor = 'rgb(235, 0, 0)';

    useEffect(() => {
        fetchAvailability();
    }, []);

    const fetchAvailability = async () => {
        try {
            const response = await axios.get('/api/public/room-availability');
            if (response.data.status === 'success') {
                setAvailability(response.data.data);
            } else {
                setError('Failed to fetch availability');
            }
        } catch (err) {
            console.error(err);
            setError('Error connecting to server');
        } finally {
            setLoading(false);
        }
    };

    const handleDateClick = (dateStr, status) => {
        if (status === 'full') {
            alert('Rooms are fully booked for this date.');
            return;
        }
        // Logic to proceed to booking
        navigate(`/booking-time?date=${dateStr}`);
    };

    // Helper to group dates by month
    const groupDatesByMonth = (data) => {
        const months = {};
        data.forEach(item => {
            const d = new Date(item.date);
            const key = `${d.toLocaleString('default', { month: 'short' })}-${d.getFullYear()}`;
            if (!months[key]) months[key] = [];
            months[key].push(item);
        });
        return months;
    };

    const groupedData = groupDatesByMonth(availability);

    if (loading) return <div className="text-center p-5">Loading calendar...</div>;
    if (error) return <div className="text-center p-5 text-danger">{error}</div>;

    return (
        <div className="container mt-5 mb-5">
            <h2 className="text-center mb-4">Room Availability</h2>

            {Object.keys(groupedData).map(monthKey => (
                <div key={monthKey} className="mb-5">
                    <h3 className="mb-3" style={{ borderBottom: '2px solid #ddd', paddingBottom: '10px' }}>{monthKey}</h3>
                    <div className="d-flex flex-wrap justify-content-center gap-3">
                        {groupedData[monthKey].map((day) => {
                            const dateObj = new Date(day.date);
                            const dayName = dateObj.toLocaleDateString('en-US', { weekday: 'short' });
                            const dayNum = dateObj.getDate();
                            const isAvailable = day.status === 'available';

                            return (
                                <div
                                    key={day.date}
                                    onClick={() => handleDateClick(day.date, day.status)}
                                    className="availability-box"
                                    style={{
                                        width: '160px',
                                        height: '140px',
                                        background: isAvailable ? greenGradient : redColor,
                                        borderRadius: '8px',
                                        boxShadow: '0px 0px 15px #d7d7d7',
                                        color: '#fff',
                                        cursor: isAvailable ? 'pointer' : 'not-allowed',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        position: 'relative',
                                        margin: '10px',
                                        transition: 'transform 0.2s'
                                    }}
                                    onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                                    onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                >
                                    <div style={{ fontSize: '1.2rem', fontWeight: 'bold', marginBottom: '5px' }}>
                                        {dayName}
                                    </div>
                                    <div style={{ fontSize: '2.5rem', fontWeight: 'bold', lineHeight: '1' }}>
                                        {dayNum}
                                    </div>
                                    <div style={{ fontSize: '0.9rem', marginTop: '5px' }}>
                                        {monthKey}
                                    </div>

                                    {isAvailable && (
                                        <div style={{
                                            marginTop: '10px',
                                            background: 'rgba(0,0,0,0.2)',
                                            padding: '2px 10px',
                                            borderRadius: '10px',
                                            fontSize: '0.8rem'
                                        }}>
                                            Available: {day.available}
                                        </div>
                                    )}
                                    {!isAvailable && (
                                        <div style={{
                                            marginTop: '10px',
                                            background: 'rgba(0,0,0,0.2)',
                                            padding: '2px 10px',
                                            borderRadius: '10px',
                                            fontSize: '0.8rem'
                                        }}>
                                            FULL
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default RoomAvailabilityCalendar;
